// Severity levels — 'block' prevents submission, 'warn' should be reviewed, 'info' is advisory.
export const SEVERITY = {
  block: { label: 'Blocking', color: 'red', bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', dot: 'bg-red-500' },
  warn: { label: 'Warning', color: 'amber', bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700', dot: 'bg-amber-500' },
  info: { label: 'Info', color: 'blue', bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', dot: 'bg-blue-500' },
};

// Scan hymn items for decisions returned by the programme API.
// Do not infer rights, country availability, or blocking severity in the browser.
export function scanRightsAlerts(items, rightsMap = {}, lyricsMap = {}, library = []) {
  const pieceMap = {};
  (library || []).forEach(piece => { pieceMap[piece.id] = piece; });
  const alerts = [];

  for (const item of (items || [])) {
    if (item.type !== 'hymn') continue;
    if (item.hostOwnText) continue;

    const piece = item.piece || pieceMap[item.pieceId];
    const lyrics = item.lyrics || lyricsMap?.[item.pieceId];
    const label = item.title || piece?.title || 'Untitled hymn';

    if (lyrics?.status === 'denied') {
      alerts.push({
        itemId: item.id,
        itemTitle: label,
        severity: 'info',
        code: lyrics.reason || '',
        title: 'Lyrics unavailable',
        detail: lyrics.reason || '',
        action: '',
      });
    }

    if (lyrics?.status === 'ok' && !lyrics.verses?.length) {
      alerts.push({
        itemId: item.id,
        itemTitle: label,
        severity: 'info',
        code: 'NO_LYRICS_RETURNED',
        title: 'No lyrics returned',
        detail: 'The programme API returned no verses for lyrics marked as available.',
        action: 'Check the programme API response for this library piece.',
      });
    }
  }

  return alerts;
}

export const blockingAlerts = alerts => (alerts || []).filter(alert => alert.severity === 'block');
export const warningAlerts = alerts => (alerts || []).filter(alert => alert.severity === 'warn');
export const infoAlerts = alerts => (alerts || []).filter(alert => alert.severity === 'info');